const __WEBPACK_NAMESPACE_OBJECT__ = require("@patsnap-ui/icon/assets/solid/info.svg");